'use client';

import { useTranslations } from 'next-intl';
import { ClientLink } from '@/app/components/shared/ClientLink';
import VideoLazyLoad from '@/app/components/shared/VideoLazyLoad';
import { FAQ } from '@/app/components/ui/FAQ';
import { SITE } from '@/app/constants';
import { reportEvent } from '@/app/utils';
import { QUESTIONS_CONFIG } from './utils';

const Questions = () => {
  const t = useTranslations('home3.questions');
  const trans = useTranslations('home3.footer');

  // 使用 utils 中的配置函数获取国际化问题列表
  const questions = QUESTIONS_CONFIG(t);

  return (
    <div className="relative flex w-full flex-col justify-center overflow-hidden">
      {/* 使用公共 FAQ 组件，传入国际化问题数据 */}
      <FAQ items={questions} title={t('title')} description={t('description')} />

      {/* CTA 部分 - 视频作为背景 */}
      <div className="relative w-full">
        {/* 视频背景 */}
        <VideoLazyLoad
          poster={
            SITE === 'global'
              ? 'https://image01.cf.vidu.studio/vidu/media-asset/footerBanner-c97e6b56.webp'
              : 'https://image01-aliyun.vidu.zone/vidu/media-asset/footerBanner-c97e6b56.webp'
          }
          videoSrc={
            SITE === 'global'
              ? 'https://image01.cf.vidu.studio/vidu/landing-page/banner.5a9fe413.mp4'
              : 'https://image01-aliyun.vidu.zone/vidu/landing-page/banner.81067f55.mp4'
          }
          className="h-[433px] w-full"
          videoClassName="object-bottom object-cover"
          preload="none"
          alt="Vidu AI video generation showcase"
        />

        {/* CTA 内容覆盖层 */}
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 bg-black/40">
          <h2 className="font-medium text-[48px] text-white md:text-[32px]">{trans('buttonTip')}</h2>
          <div className="flex gap-4 md:flex-col-reverse">
            {/* 客户端App下载按钮 本期不上 */}
            {/* <div className="flex h-12 items-center justify-center gap-4 rounded-full bg-system-white24 px-4 py-2 backdrop-blur-[10px] md:h-11">
              <div className="flex cursor-pointer items-center justify-center gap-2 text-white">
                <AppleWhite className="size-[16px] md:size-[12px]" />
                <div className="text-[16px] md:text-[12px]">ios</div>
              </div>
              <div className="mx-1.5 flex h-4 w-[1px] bg-[#FFF] opacity-10" />
              <div className="flex cursor-pointer items-center justify-center gap-2 text-white">
                <AndroidWhite className="size-[16px] md:size-[12px]" />
                <div className="text-[16px] md:text-[12px]">Android</div>
              </div>
            </div> */}
            <ClientLink
              href="/home"
              onClick={() => {
                reportEvent('element_click', {
                  element_name: 'landing - trynow',
                });
              }}
              className="flex cursor-pointer items-center justify-center gap-2 rounded-full bg-system-blue02 px-10 py-2 font-semibold text-[16px] text-white shadow-lg transition-all hover:shadow-xl md:text-[14px] md:leading-[28px]"
            >
              {trans('button')}
            </ClientLink>
          </div>
        </div>
      </div>

      {/* 底部反射效果 */}
      <div className="-mt-[2px] relative flex w-full scale-y-[-1] items-center justify-center">
        <VideoLazyLoad
          poster={
            SITE === 'global'
              ? 'https://image01.cf.vidu.studio/vidu/media-asset/footerBanner-c97e6b56.webp'
              : 'https://image01-aliyun.vidu.zone/vidu/media-asset/footerBanner-c97e6b56.webp'
          }
          videoSrc={
            SITE === 'global'
              ? 'https://image01.cf.vidu.studio/vidu/landing-page/banner.5a9fe413.mp4'
              : 'https://image01-aliyun.vidu.zone/vidu/landing-page/banner.81067f55.mp4'
          }
          className="h-[155px] w-full"
          videoClassName="object-bottom object-cover"
          preload="none"
          alt="Vidu AI video generation showcase reflection"
        />
        <div className="absolute h-[157px] w-full bg-gradient-to-b from-black to-black/60 backdrop-blur-[10px]" />
      </div>
    </div>
  );
};

export default Questions;
